import React from "react";
import HeroSection from "../components/home/HeroSection";
import UsaHubSection from "../components/home/UsaHubSection";
import PersonasSection from "../components/home/PersonasSection";
import { WatchSection, GlossaryPreview, HowItWorksSection, FinalCTA } from "../components/home/HomeSections";

export default function Home() {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <UsaHubSection />
      <PersonasSection />
      <WatchSection />
      <GlossaryPreview />
      <HowItWorksSection />
      <FinalCTA />
    </main>
  );
}
